/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpreviewadmit2Inputs */

const en_ticketpreviewadmit2 = /** @type {(inputs: Ticketpreviewadmit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admit one`)
};

const de_ticketpreviewadmit2 = /** @type {(inputs: Ticketpreviewadmit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einlass`)
};

/**
* | output |
* | --- |
* | "Admit one" |
*
* @param {Ticketpreviewadmit2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpreviewadmit2 = /** @type {((inputs?: Ticketpreviewadmit2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpreviewadmit2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpreviewadmit2(inputs)
	return de_ticketpreviewadmit2(inputs)
});
export { ticketpreviewadmit2 as "ticketPreviewAdmit" }